import React from "react";
import { FormattedMessage } from "react-intl";

import { modalFactory } from "common/components/ModalDialog";

/**
 * @param  {[object]} availableFilterGroups An object containing the list of predefined filters
 * @param  {[object]} selectedFilters Object of currently selected filters
 * @param  {[function]} setSelectedFilters Callback when a new filter needs to be set
 * @return {[element]} A modal factory callback to be called when user wants to open the modal filter dialog
 */
export const FilterModal = (
  availableFilterGroups,
  selectedFilters,
  setSelectedFilters
) => {
  // Create a local list of the selectedFilters
  const localSelectedFilters = (selectedFilters || []).map(filter => filter);

  // Build the template for the filter list
  const availableFilters = [];
  Object.keys(availableFilterGroups).forEach(filterType => {
    const filters = availableFilterGroups[filterType];
    if (filters) {
      filters.forEach(filter => {
        const checked = localSelectedFilters.includes(filter);
        availableFilters.push(
          <div key={filter.translationKey}>
            <input
              id={
                "cfps-modal-" + filterType + "-filter-" + filter.translationKey
              }
              type="checkbox"
              onClick={e =>
                updateFilterList(filter, e.target.checked, localSelectedFilters)
              }
              defaultChecked={checked}
            />
            <label
              htmlFor={
                "cfps-modal-" + filterType + "-filter-" + filter.translationKey
              }
            >
              <span>
                <FormattedMessage id={filter.translationKey} />
              </span>
            </label>
          </div>
        );
      });
    }
  });

  // Closes the modal and sets the filters
  const submitChanges = () => {
    setSelectedFilters(localSelectedFilters);
  };

  var filterOptions = modalFactory({
    dialog: {
      title: "alphaFilters.ADD_REMOVE_FILTERS"
    },
    reject: {
      message: "cancel"
    },
    confirm: {
      message: "OK",
      buttonClass: "primary",
      handler: submitChanges
    },
    customUI: <div className="cfps-modal-filters">{availableFilters}</div>
  });

  return filterOptions;
};

// Function used to update the elements in the list. (It is exported so that it can be tested)
export const updateFilterList = (filter, checked, filters) => {
  if (checked) {
    if (!filters.includes(filter)) {
      filters.push(filter);
    }
  } else {
    const index = filters.findIndex(
      selectedFilter => selectedFilter === filter
    );
    if (index >= 0) {
      filters.splice(index, 1);
    }
  }
};
